import { Formik } from "formik";
import { useRef, useState } from "react";
import CMSFormTelephone from "../formFields/CMSFormTelephone";
import CMSFormInput from "../formFields/CMSFormInput";
import CMSFormTextArea from "../formFields/CMSFormTextArea";
import { partySchema } from "../utils/validations";
import GeneralButton from "./GeneralButton";
import ContainerLoading from "./loading/ContainerLoading";
import { motion } from "framer-motion";
import success from "../../assets/images/success.png";
import { useToast } from "../contexts/ToastContext";
import CMSFormDate from "../formFields/CMSFormDate";
import CMSFormTime from "../formFields/CMSFormTime";
import axios from "../../config/axios";
import dummy from "../../assets/images/party.png";
const PartyCateringForm = ({ content }) => {
  const [status, setStatus] = useState("idle"); // "idle" | "loading" | "success"
  const { addToast } = useToast();
    const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const refs = {
    parentName: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    eventDate: useRef(null),
    eventTime: useRef(null),
    address: useRef(null),
    city: useRef(null),
    occasion: useRef(null),
    numberOfChildren: useRef(null),
    message: useRef(null),
  };

  const scrollToFirstError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];
    if (!firstErrorField || !refs[firstErrorField]?.current) return;

    const el = refs[firstErrorField].current;
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    setTimeout(() => el.focus?.({ preventScroll: true }), 500);
  };

  // --- Submission function ---
  const submitPartyForm = async (values, resetForm) => {
    const cleanValues = {
      ...values,
      eventDate: values.eventDate ? values.eventDate.split("T")[0] : "", // ✅ keep only YYYY-MM-DD
    };

    setStatus("loading");
    try {
      const response = await axios.post("/save-party-request", cleanValues);

      if (
        response.status === 200 ||
        response.status === 201 ||
        response.data.success
      ) {
        setStatus("success");
        //addToast("Your request has been submitted successfully!", "success");

        setTimeout(() => {
          resetForm();
          setStatus("idle");
        }, 10000);
      } else {
        throw new Error(response.data?.message || "Submission failed");
      }
    } catch (err) {
      console.error(err);
      setError("Submission failed, please try again");
      setTimeout(() => {
        setError("");
      }, 5000);
      setStatus("idle");
    }
  };

  return (
    <>
      <div className="grid lg:grid-cols-[2.8fr_1fr] 2xl:grid-cols-[2.2fr_1fr] 2.5xl:grid-cols-[2fr_1fr] gap-4 lg:gap-10 ">
        <div
          className={`${
            status === "success" ? "bg-secondary" : "bg-[#DEE2DD]/50"
          } p-10  lg:px-12 1xl:px-20 lg:py-10  rounded-[15px] relative  order-2 lg:order-1 flex flex-col justify-center`}
        >
          {status != "success" && (
            <div className="w-full 2.5xl:px-0  mb-2 lg:mb-6">
              <p className="text-34pt lg:text-36pt pb-4 lg:pb-2">
                {content?.heading || "Party Catering"}
              </p>
              {content?.shortDescription && (
                <div className="text-secondary font-mono text-20pt md:text-24pt mb-6">
                  {content.shortDescription}
                </div>
              )}
            </div>
          )}

          {/* Loading */}
          {status === "loading" && (
            <div className="absolute inset-0 flex items-center justify-center rounded-[15px] z-10">
              <ContainerLoading />
            </div>
          )}

          {/* Success */}
          {status === "success" && (
            <motion.div
              initial={{ x: -200, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -200, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <div className="grid grid-cols-1 gap-8 ">
                <div>
                  <div className="w-full rounded-[15px] ">
                    <div className="grid grid-cols-1 lg:grid-cols-[2.5fr_1fr] 2.5xl:grid-cols-[2.5fr_1fr] gap-3 md:gap-4 2.5xl:gap-28 mt-0">
                      <div className=" px-0 xl:p-5 flex flex-col justify-between order-2 lg:order-1">
                        <div className="w-full">
                          <p className="text-white text-28pt md:text-48pt leading-none mb-8 text-center lg:text-left">
                            Submission Successful
                          </p>

                          <p className="text-orange text-[25px] md:text-[34px] leading-none text-center lg:text-left">
                            Thank you for your submission, we will get back to
                            you soon.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center justify-center order-1 lg:order-2">
                        <img
                          src={success}
                          alt="success"
                          className="w-[80px] h-[80px] md:w-[110px] md:h-[110px] lg:w-[134px] lg:h-[134px]"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          )}

          {/* Form */}
          {status !== "success" && (
            <Formik
              initialValues={{
                parentName: "",
                email: "",
                phone: "",
                eventDate: "",
                eventTime: "",
                address: "",
                city: "",
                occasion: "",
                numberOfChildren: "",
                message: "",
              }}
              validationSchema={partySchema}
              onSubmit={(values, { resetForm }) =>
                submitPartyForm(values, resetForm)
              }
            >
              {(form) => (
                <div className="w-full grid grid-cols-1 gap-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <CMSFormInput
                      name="parentName"
                      label="Parent Name"
                      form={form}
                      className="1"
                      ref={refs.parentName}
                      required
                    />
                    <CMSFormInput
                      name="email"
                      label="Email"
                      form={form}
                      className="1"
                      ref={refs.email}
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <CMSFormTelephone
                      name="mobile"
                      label="Phone"
                      form={form}
                      className="1"
                      ref={refs.phone}
                      required
                    />
                    <CMSFormDate
                      name="eventDate"
                      label="Event Date"
                      form={form}
                      className="1"
                      ref={refs.eventDate}
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <CMSFormInput
                      name="eventTime"
                      label="Event Time"
                      form={form}
                      className="1"
                      ref={refs.eventTime}
                      required
                    />
                    <CMSFormInput
                      name="address"
                      label="Address"
                      form={form}
                      className="1"
                      ref={refs.address}
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <CMSFormInput
                      name="city"
                      label="City"
                      form={form}
                      className="1"
                      ref={refs.city}
                      required
                    />
                    <CMSFormInput
                      name="occasion"
                      label="Occasion"
                      form={form}
                      className="1"
                      ref={refs.occasion}
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
                    <CMSFormInput
                      name="numberOfChildren"
                      label="Number of Children"
                      form={form}
                      className="1"
                      ref={refs.numberOfChildren}
                      required
                    />
                  </div>

                  <CMSFormTextArea
                    name="message"
                    label="Message"
                    form={form}
                    ref={refs.message}
                    maxLength={300}
                    required
                  />
                  {error && (
                    <div
                      className={`relative transition-all duration-300 ease-in-out ${
                        error
                          ? "opacity-100 translate-y-0"
                          : "opacity-0 -translate-y-2"
                      }`}
                    >
                      {error && <span className="errorMessage">{error}</span>}
                    </div>
                  )}
                  <div className="flex items-end justify-end">
                    <GeneralButton
                      text="Submit"
                      type="submit"
                      title="Click to submit"
                      className="text-lg px-4"
                      onClick={() => {
                        form.handleSubmit();
                        setTimeout(() => scrollToFirstError(form?.errors), 100);
                      }}
                    />
                  </div>
                </div>
              )}
            </Formik>
          )}
        </div>
       <div className="xl:max-h-[470px]  rounded-[15px] overflow-hidden order-1 lg:order-2 relative">
         {loading && (
        <div className="w-full flex justify-center items-center py-4 absolute top-0 left-0 h-full">
          <span className="text-gray-500">Loading...</span>
        </div>
      )}
        <img
          src={
            process.env.REACT_APP_BACKEND_URL + "public/" + content?.bannerImage
          }
          onLoad={() => setLoading(false)}
          onError={(e) => {
            e.currentTarget.src = require("../../assets/images/link.png");
            setLoading(false);
          }}
          alt="image"
          className="w-full h-auto object-contain"
        />
      </div>
      </div>
    </>
  );
};

export default PartyCateringForm;
